if (!customElements.get('video-component')) {
  class VideoComponent extends HTMLElement {
    constructor() {
      super();

      this.elVideo = this.querySelector('video');
      this.loaded = false;

      this.observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          let shouldLoad = entry.isIntersecting && !this.loaded;
          shouldLoad && this.lazyLoadVideo();
        });
      });

      this.observer.observe(this);
    }

    lazyLoadVideo() {
      this.querySelector('video').outerHTML = JSON.parse(this.getAttribute('data-video'));
      this.querySelector('video').classList.add('in-view');
      this.loaded = true;
      this.bind();
      this.dispatchEvent(new CustomEvent('video:loaded', { bubbles: true }));
    }

    bind() {
      this.elVideo = this.querySelector('video');
      this.elPlay = this.querySelector('[data-play]');
      this.elSound = this.querySelector('[data-sound]');
      this.elProgress = this.querySelector('progress');

      this.elVideo.addEventListener('suspend', () => {
        this.updatePlayButton();
        this.setAttribute('data-audio', !this.elVideo.muted);
      });

      setTimeout(() => {
        this.updatePlayButton();
      }, 100);

      this.elPlay && this.elPlay.addEventListener('click', this.toggleVideo.bind(this));
      this.elSound && this.elSound.addEventListener('click', this.toggleAudio.bind(this));
      this.elProgress && this.elVideo.addEventListener('timeupdate', this.trackProgress.bind(this));
    }

    trackProgress(ev) {
      const { duration, currentTime } = this.elVideo;
      duration && (this.elProgress.value = Math.round((currentTime / duration) * 100));
    }

    toggleVideo() {
      this.elVideo && this.elVideo.paused ? this.elVideo.play() : this.elVideo.pause();
      this.updatePlayButton();
    }

    playVideo(shouldMute = false) {
      this.elVideo.muted = shouldMute;
      this.setAttribute('data-audio', !this.elVideo.muted);
      this.elVideo && this.elVideo.play();
      this.elPlay && (this.elPlay.innerHTML = 'Pause');
    }

    pauseVideo(shouldStop = false) {
      this.elVideo && this.elVideo.pause();
      this.updatePlayButton();
      shouldStop && this.elVideo && (this.elVideo.currentTime = 0.5);
    }

    toggleAudio() {
      this.elVideo.muted = !this.elVideo.muted;
      this.setAttribute('data-audio', !this.elVideo.muted);
    }

    updatePlayButton() {
      this.elPlay && this.elPlay.classList.toggle('playing', !this.elVideo.paused);
      this.elPlay && (this.elPlay.innerHTML = `<span class="visually-hidden">${this.elVideo.paused ? 'Play' : 'Pause'}</span>`);
    }
  }

  customElements.define('video-component', VideoComponent);
}